export const DasInstallmentStatus = {
	0: "NoDebt",
	1: "ActiveDebt",
	2: "ProposalSent",
	3: "NotAccepted",
	4: "ActiveInstallment"
};
